import React, {useState, useContext} from 'react'
import { useEffect } from 'react';
import {Modal} from 'react-bootstrap';
import {EditedContext, LoadingContext} from '../../../../partials/Context'
import getCookie from '../../../../partials/cookie';
import { Errors } from '../../../../partials/Partials';

function RecommendationModal({show, setShow, setRecommendationSent}) {
    const edited = useContext(EditedContext);
    const {setLoading} = useContext(LoadingContext);
    const {lawyer_data} = edited || '';
    const {recommendation_url} = lawyer_data || '';
    const [errors, setErrors] = useState([]);

    useEffect(() => {
        setErrors([])
    },[])

    const handleSubmit = (e) => {
        e.preventDefault();
        const email_value = e.target.querySelector('#email').value
        setLoading(true)
        const csrftoken = getCookie('csrftoken');
        let formData = new FormData()
        formData.append('review_email', email_value);

        fetch(`${recommendation_url}`, {
            method: 'POST',
            headers: {
                    "X-CSRFToken": csrftoken
                },
            body: formData
        }).then(res => {
            if (res.ok) {
                setLoading(false)
            } else {
                setErrors(['Błąd wysyłania wiadomości'])
                setLoading(false)
            }
        })
        setRecommendationSent(true);
        setShow(false)
    }

  return (
    <Modal show={show}  onHide={() => setShow(false)}  id="recommendation-modal">
        <Modal.Header closeButton>
            <Modal.Title>
                Zaproszenie do wystawienia rekomendacji
            </Modal.Title>
        </Modal.Header>
        <form onSubmit={(e)=>handleSubmit(e)}>
        <Modal.Body>
                <Errors errors={errors} />
                <p>Podaj adres e-mail prawnika, do którego mamy wysłać prośbę o rekomendację</p>
                <input type="email" placeholder="email" id="email" required/>
                
        </Modal.Body>
        <Modal.Footer>
            <div className="buttons">
                <button type="button"className="btn btn-default" id="cancel" onClick={()=>setShow(false)}>Zamknij</button>
                <button className="btn btn-success">Wyślij</button>
            </div>
        </Modal.Footer>
        </form>
    </Modal>
  )
}

export default RecommendationModal